import * as React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Slide,
    Box
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ModalSuccess({ open }) {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate("../");
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            fullWidth
            maxWidth="xs"
        >
            <DialogContent sx={{ textAlign: 'center', py: 4 }}>
                <Box mb={2}>
                    <CheckCircleOutlineIcon
                        sx={{ fontSize: 60, color: 'success.main' }}
                    />
                </Box>

                <DialogTitle sx={{ fontWeight: 'bold', p: 0 }}>
                    Tudo certo! 🎉
                </DialogTitle>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mt: 2 }}
                >
                    Sua operação foi concluída com sucesso.
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 1 }}
                >
                    Em instantes você receberá um e-mail com todos os detalhes.
                    Caso não encontre, verifique também a caixa de spam.
                </Typography>
            </DialogContent>

            <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button
                    variant="contained"
                    color="success"
                    onClick={handleClose}
                    size="large"
                >
                    Continuar
                </Button>
            </DialogActions>
        </Dialog>
    );
}